import { FC } from "react";
import ReactDOM from "react-dom";
import PromoSection from "./components/Navigation/PromoSection";
import useContentful from "./hooks/useContentful";
interface IndexProps {
  entryId: string;
  locale: string;
}

const Index: FC<IndexProps> = ({ entryId, locale }) => {
  if (entryId !== 'some-id' || undefined || null) {
    const { contentfulData } = useContentful({ include: 10, 'sys.id': entryId, locale: locale || 'en-US' });
    const fields: any = contentfulData?.items[0]?.fields;

    if (contentfulData) {
      // @ts-ignore
      return <PromoSection fields={fields} />;
    }

    return null;
  }
};

document.querySelectorAll('[id^="navigation-promo-"]').forEach(div => {
  const entryId = div.getAttribute('data-contentfulid');
  const locale = div.getAttribute('data-locale');
  if (entryId && locale) {
    ReactDOM.render(<Index entryId={entryId} locale={locale} />, div);
  }
});